import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export const PrivateRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-yellow-500"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    // Check if this was a customer session - redirect to customer login
    const lastCalendarSymbolicName = localStorage.getItem('lastCalendarSymbolicName');
    const lastUserRole = localStorage.getItem('lastUserRole');
    
    if (lastUserRole === 'customer' && lastCalendarSymbolicName) {
      // Don't remove lastUserRole here - it might be needed for multiple renders
      // It will be cleared when user logs in again
      return <Navigate to={`/customer/login/${lastCalendarSymbolicName}`} replace />;
    }
    
    return <Navigate to="/login" replace />;
  }

  return children;
};

export const AdminRoute = ({ children }) => {
  const { isAuthenticated, isAdmin, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-yellow-500"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  return isAdmin() ? children : <Navigate to="/dashboard" />;
};
